import { render, staticRenderFns } from "./SilverCloudSearch.vue?vue&type=template&id=38f36f62"
import script from "./SilverCloudSearch.vue?vue&type=script&lang=js"
export * from "./SilverCloudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports